import "normalize.css";
import "flag-icon-css/css/flag-icon.min.css";
import "./less/global.less";
import "./less/country-page.less";
import "./less/faq.less";
import "./less/regionRestrictions.less";
import "./helpers/slideupdown.js";


import Vue from "vue";

Vue.config.productionTip = false;
import currency from "./helpers/currency.js";
Vue.use(currency);

// eslint-disable-next-line no-new
new Vue({
  el: "#app",
  components: {
    ExternalBanners: () => import("./components/ExternalBanners"),
  },
});
